import { render, staticRenderFns } from "./BC_articleList.vue?vue&type=template&id=23200bd4&"
import script from "./BC_articleList.vue?vue&type=script&lang=js&"
export * from "./BC_articleList.vue?vue&type=script&lang=js&"
import style0 from "./BC_articleList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports